import React, { useState, useEffect, useRef } from "react";
import { Input, Button, Tag, AutoComplete, message, Spin, Tooltip } from "antd";
import { UploadOutlined, MessageOutlined, FileTextOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { API_URL, BASE_URL, WS_BASE_URL } from "../../../utils/Constant";
import { decryptData, downloadFile, encryptData, limitWords } from "../../../utils/utils";
import axiosInstance from "../../../utils/axiosInstance";
import { useSelector } from "react-redux";
import { readMessages } from "../../../utils/pushNotification";

function Chat({ id }) {
  const [messageInput, setMessageInput] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [isMentioning, setIsMentioning] = useState(false);
  const [filePreview, setFilePreview] = useState(null);
  const [fileType, setFileType] = useState(null); // state to store file type
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [file, setFile] = useState(null);
  const [ groupMembers, setGroupMembers] = useState([])
  const popupRef = useRef(null);
  const socketRef = useRef(null)
  const isFetching = useRef(false);
  const chatBoxRef = useRef(null);
  const select = useSelector((state) => state.auth);
  const userId =  select.userInfo.user_id;
  const token = select.accessToken;
  const publicKey = select.userInfo.public_key;
  const privateKey = select.userInfo.private_key;

  useEffect(() => {
    if (chatBoxRef.current && page === 1 && isPopupVisible) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight; // scroll to bottom whenever messages update 
    }
    if(isPopupVisible){
      const payload = {
        user_id:userId,
        // notification_id: id
      }
      // readMessages(payload)
    }
  }, [allMessages, isPopupVisible]);

  

  const fetchEmails = async (pageNum) => {
    try {
      const response = await axiosInstance.get( `/contract/${id}/access-users-emails/`);
      setGroupMembers(response.data.users);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const fetchPastMessages = async (pageNum) => {   //infinity scroll
    if (isFetching.current || !hasMore) return;
    isFetching.current = true;

    try {
      const payload = {
        agreement_id: id,
        page: pageNum,
        page_size: 20
      }

      const response = await axiosInstance.post( `/chat/history/`,payload);
      const reverse = response.data.chat_history.reverse()
      setHasMore(response?.data?.has_next);
      setPage(pageNum);
      setAllMessages((prev) => [...reverse, ...prev]); 
        if (chatBoxRef.current) {
          const oldScrollHeight = chatBoxRef.current.scrollHeight;
          requestAnimationFrame(() => {
            const newScrollHeight = chatBoxRef.current.scrollHeight;
            chatBoxRef.current.scrollTop += newScrollHeight - oldScrollHeight; // Maintain position
          });
        }

    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      isFetching.current = false;
    }
  };

  const handleScroll = () => {
    if (!chatBoxRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = chatBoxRef.current;
    const scrollPosition = Math.abs(scrollTop); // Ensure it's positive
    const scrollThreshold = scrollHeight * 0.1; // 90% scrolled up
    if (scrollPosition <= scrollThreshold && hasMore && !isFetching.current) {
      fetchPastMessages(page + 1);
    }
  };


  useEffect(() => {
    const connectWebSocket = () => {
      // AS we know socket.io is best option for this Situation, The backend developer told me he was not able to use socket.io because the backend framework did not support the socket.io library. That is why we use web sockets here.
      // socketRef.current = new WebSocket(`ws://192.168.29.136:8081/ws/chat/${id}/?token=${token}`);
      console.log(WS_BASE_URL,API_URL,`${WS_BASE_URL}/ws/chat/${id}`, 'WS_BASE_URL 009')
      socketRef.current = new WebSocket(`${WS_BASE_URL}/ws/chat/${id}/?token=${token}`);


      socketRef.current.onopen = () => {
        console.log("WebSocket connected");
      };

      socketRef.current.onmessage = (event) => {
        try {
          const messageData = JSON.parse(event.data);
          setAllMessages((prev) => [...prev, messageData.message_content]);
        } catch (err) {
          console.error("Invalid JSON from WebSocket:", err);
        }
      };

      socketRef.current.onclose = (event) => {
        console.warn(`WebSocket closed: ${event.code}`, event.reason);
        setTimeout(() => connectWebSocket(), 5000); // Reconnect after 5 seconds
      };

      socketRef.current.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };
    };
    if (socketRef.current && socketRef?.current?.readyState === WebSocket?.OPEN) { // ye kya h 
      socketRef.current?.close();
    }
    if (!!id) {
      connectWebSocket();
      fetchEmails()
      fetchPastMessages(1); // Load first page
    }
    return () => {
      socketRef.current?.close();
    };
  }, [id]); // Reconnect if `id` changes

  const handleSendMessage = () => {

    if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) { //WebSocket connection exists 
      message.error("WebSocket is not connected.");
      return;
    }

    if (messageInput.trim() === "" && !filePreview) {  // ?
      message.warning("Message cannot be empty!");
      return;
    }
    const cleanMessage = messageInput.replace(/^\n+|\n+$/g, ''); // remoce extra enters 

    const messageData = {
      files: filePreview
        ? [
          {
            type: fileType,
            name: file.name,
            data: filePreview, // Base64 Data
          },
        ]
        : [],
      message: encryptData(cleanMessage),
      author_id: userId,
    };
    socketRef.current.send(JSON.stringify(messageData));  //data ko server pe bhejti hai

    setMessageInput("");
    setFilePreview(null);
    setFileType(null);
    setFile(null);
  };

  const handelOnSelect = (value) => {
    const words = messageInput.split("@");
    words[words.length - 1] = value;
    const newMessageInput = words.join("@");
    setMessageInput(newMessageInput);
  }

  const handleMessageChange = (value) => {
    setMessageInput(value);
    if (value.includes("@")) {
      const partAfterAt = value?.split("@")?.pop()?.toLowerCase();
      if (partAfterAt?.length > 0) {
        let matchEmails = []
        groupMembers.filter((member) => {
          const nameEmail = member.full_name+' '+member.email;
          nameEmail.toLowerCase()
          if (nameEmail.includes(partAfterAt)) {
            matchEmails.push({ value: `${member.email}(${member.full_name})` })
          }
        })
        setEmailSuggestions(matchEmails);
        setIsMentioning(true);
      } else {
        setIsMentioning(false);
        setEmailSuggestions([]);
      }
    } else {
      setIsMentioning(false);
      setEmailSuggestions([]);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIsLoading(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setIsLoading(false);
        setFile(file);
        setFileType(file.type.startsWith("image/") ? "image" : "document");
        setFilePreview(reader.result); // Base64 Data
      };
      reader.readAsDataURL(file);

    } else {
      message.error("Invalid file type!");
    }
  };

  const handleFileRemove = () => {
    setFilePreview(null);
    setFileType(null);
    setFile(null);
  };

  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (items) {
        for (const item of items) {
          if (item.type.startsWith("image/")) {
            const file = item.getAsFile();
            if (file) {
              handleFileChange({ target: { files: [file] } }); // reuse your existing handler
            }
          }
        }
      }
    };

    window.addEventListener("paste", handlePaste);

    return () => {
      window.removeEventListener("paste", handlePaste);
    };
  }, []);
    

  return (
    <div className="fixed bottom-6 right-6 " style={{ zIndex: 99999 }}>
{/* <Button
  type="primary"
  shape="circle"
  icon={<MessageOutlined className="text-2xl" />}
  onClick={() => setIsPopupVisible(!isPopupVisible)}
  className="w-16 h-16 flex items-center justify-center shadow-lg hover:shadow-xl transition duration-300"
/> */}

      <Button
        type="primary"
        shape="circle"
        icon={<MessageOutlined className="text-2xl" />}
        size="large"
        onClick={() => setIsPopupVisible(!isPopupVisible)}
        className="shadow-lg hover:shadow-xl transition duration-300"
      />

      { isPopupVisible && (
        <div
          ref={popupRef}
          className="fixed z-[1] bottom-20 right-6 w-96 h-[80%] bg-white rounded-2xl shadow-2xl overflow-auto p-4 flex flex-col"
        >
          <h3 className="text-lg font-semibold text-gray-700 border-b pb-2 mb-3">
            Chat
          </h3>
          <div
            className="flex-grow overflow-y-auto space-y-2"
            ref={chatBoxRef}
            onScroll={handleScroll}
          >
            {isFetching.current && <p className="text-center text-sm text-gray-500">Loading more...</p>}
            {allMessages.map((msg, index) => (
              <div
                key={index}
                className={`flex ${msg.author_id == userId ? "justify-end" : "justify-start"}`}
              >
                <div
                  className={`p-3 rounded-lg w-fit max-w-xs shadow-md ${ msg.author_id == userId
                    ? "bg-blue-600 text-white self-end"
                    : "bg-gray-200 text-gray-800 self-start"
                    }`}
                >
                  {/* Sender Name */}
                  <p className="font-semibold">{msg.author_name}</p>

                  {/* Message */}
                  <p className="text-sm mt-1 break-words w-full">
                    <pre className="whitespace-pre-wrap break-words w-full">{decryptData(msg.message)}</pre>
                  </p>


                  {/* Image Attachment */}

                  {!!msg.files && msg.files[0]?.file_type === "image" && (
                    <div className="relative group">
                      <img
                        src={ process.env.NODE_ENV === "development" ? BASE_URL + msg?.files[0]?.file_url : msg?.files[0]?.file_url}
                        alt={msg?.files[0]?.file_name}
                        className="w-full rounded mt-2"
                      />
                      <button
                        onClick={() =>
                          downloadFile( process.env.NODE_ENV === "development" ? BASE_URL + msg?.files[0]?.file_url : msg?.files[0]?.file_url, msg?.files[0].file_name, true)
                        }
                        className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"
                      >
                        <DownloadOutlined className="text-white text-3xl bg-blue-600 p-3 rounded-full shadow-lg transition-transform transform scale-100 group-hover:scale-110" />

                      </button>
                    </div>
                  )}

                  {/* Document Attachment */}
                  {!!msg.files && msg.files[0]?.file_type === "document" && (
                    <div className={`mt-2 fl ex items-center ${msg.author_id == userId
                      ? 'text-gray-200' : 'rgb(136, 113, 226)'} `} >
                      <FileTextOutlined className="mr-2" />
                      <span className="text-xs truncate">{msg?.files[0].file_name}</span>
                      <DownloadOutlined onClick={() => { downloadFile( process.env.NODE_ENV === "development" ? BASE_URL + msg?.files[0]?.file_url : msg?.files[0]?.file_url, msg?.files[0].file_name, true) }} className="ml-3 cursor-pointer  text-lg" />
                    </div>
                  )}

                  {/* Tagged Emails */}
                  {msg?.taggedEmails?.length > 0 && (
                    <div className="mt-1 text-xs text-gray-500">
                      Tagged:{" "}
                      {msg?.taggedEmails?.map((email, idx) => (
                        <Tag key={idx} color="blue">
                          {email}
                        </Tag>
                      ))}
                    </div>
                  )}

                  {/* Timestamp */}
                  <p className="text-xs opacity-70 mt-2 text-right">
                    {new Date(msg.timestamp)?.toLocaleString()}
                  </p>
                </div>
              </div>
            ))}

          </div>

          <div className="relative z-[0]  overflow-visible  mt-3">
            <AutoComplete
              value={messageInput}
              onChange={handelOnSelect}
               placement="topLeft"
              // placeholder="Type your message..."
              dropdownVisible={isMentioning}
              className="w-full"
              popupClassName="z-[999999]"
              options={emailSuggestions}
                  // className="p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <Input.TextArea
                value={messageInput}
                onChange={(e) => handleMessageChange(e.target.value)}
                placeholder="Type your message..."
                onPressEnter={(e) => {
                  if (!e.shiftKey) { // Shift + Enter for new line, Enter to send
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}
                rows={3}
                className="z-[10] p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              />
            </AutoComplete>

            <div className="top-10 mt-3">
              <input
                type="file"
                accept="image/*,application/pdf,.docx,.txt"
                onChange={handleFileChange}
                className="hidden"
                id="file-upload"
              />
              <label
                htmlFor="file-upload"
                className=" z-[99] fixed bottom-40 right-10 transform -translate-y-1/2 cursor-pointer text-blue-500 flex items-center"
              >
                <UploadOutlined className="mr-1 text-3xl" />
              </label>
            </div>


            {filePreview && fileType === "image" && (
              <div className="mt-3 relative">
                <img
                  src={filePreview}
                  alt="Preview"
                  className="w-full rounded-lg"
                />
                <DeleteOutlined
                  onClick={handleFileRemove}
                  className="absolute top-2 right-2 text-red-500 cursor-pointer"
                />
              </div>
            )}

            {filePreview && fileType === "document" && (
              <div className="mt-3 flex items-center">
                <FileTextOutlined className="mr-2 text-gray-600" />
                {/* <Tooltip title={filePreview}> */}
                <span>{limitWords(filePreview)}</span>
                {/* </Tooltip > */}
                <DeleteOutlined
                  onClick={handleFileRemove}
                  className="ml-2 text-red-500 cursor-pointer"
                />
              </div>
            )}

            <Button
              type="primary"
              onClick={handleSendMessage}
              className="w-full mt-3  bg-blue-500 hover:bg-blue-600 rounded-lg shadow-md"
            >
              {isLoading ? <Spin size="small" /> : "Send Message"}
            </Button>
          </div>
        </div>
      ) }
    </div>
  );
}

export default Chat;
